import { Component, computed } from '@angular/core';
import { ItemDisabledFn, KENDO_DROPDOWNLIST } from '@progress/kendo-angular-dropdowns';
import { AngularBaseFieldWidget } from '../angular-base-field-widget';
import { AngularSelectField, AngularSelectOption } from '../angular-form-fields';

@Component({
	selector: 'angular-select-field',
	imports: [KENDO_DROPDOWNLIST],
	templateUrl: './angular-select-field.widget.html',
})

export class AngularSelectFieldWidget<T> extends AngularBaseFieldWidget<AngularSelectField<T>> {

	public defaultItem: AngularSelectOption<null> = {
		text: 'Select...',
		value: null,
		disabled: true,
	};

	readonly options = computed(() => {
		const options = this.field().options();

		const validations = this.field().validations;

		// If the field is not required, add a "None Selected" option at the bottom of the list
		if (validations && !validations.isRequired?.()) {

			// value MUST be null, not undefined. 
			// Setting a value to `undefined` causes Angular's signal form engine to remove the key from the reactive model, triggering`NG01902: Orphan field` errors.
			return [...options, { text: 'None Selected', value: null }];
		}

		return options;
	});


	public isItemDisabled: ItemDisabledFn = (itemArgs) => {
		return itemArgs.dataItem.disabled;
	};
}